<template>
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
  <path fill="#52A500" fill-rule="evenodd" d="M7.634 1.25a.75.75 0 0 1 .75.75v7.523l2.053-2.053a.75.75 0 0 1 1.06 1.06l-3.333 3.334-.53.53-.53-.53L3.77 8.53a.75.75 0 0 1 1.061-1.06l2.053 2.053V2a.75.75 0 0 1 .75-.75Zm-5.333 12a.75.75 0 0 0 0 1.5h11.4a.75.75 0 0 0 0-1.5H2.3Z" clip-rule="evenodd"/>
</svg>
</template>
